export const TRACKER_PAYMENT_PENDING_BANNER_OPEN = '[Payment Pending] banner open';
export const TRACKER_PAYMENT_PENDING_BANNER_CLOSE = '[Payment Pending] banner close';
export const TRACKER_PAYMENT_PENDING_BANNER_CLOSE_CLICK = '[Payment Pending] banner close click';
export const TRACKER_PAYMENT_PENDING_PAY_NOW_CLICK = '[Payment Pending] pay now click';
export const TRACKER_PAYMENT_PENDING_VIEW_PENDING_INVOICES_CLICK = '[Payment Pending] view pending invoices click';
export const TRACKER_PAYMENT_PENDING_TO_PAYMENT_METHODS_CLICK = '[Payment Pending] payment methods click';
